if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Invoked when the custom element is first connected to the document's DOM.
        this.initPointerEvents();
      }

      disconnectedCallback() {
        // Invoked when the custom element is disconnected from the document's DOM.
      }

      connectedMoveCallback() {
        // Invoked when custom element is moved with moveBefore()
      }

      adoptedCallback() {
        // Invoked when the custom element is moved to a new document.
      }

      attributeChangedCallback(name, oldValue, newValue) {
        // Invoked when one of the custom element's attributes is added, removed, or changed.
      }

      initPointerEvents() {
        const imageContainers = this.querySelectorAll('.shop-the-look__image-container');
        imageContainers.forEach((container) => {
          const productPoints = container.querySelectorAll('.product-point');
          productPoints.forEach((point) => {
            const windowWidth = window.innerWidth;
            if (windowWidth >= 768) {
              point.addEventListener('mouseover', (event) => {
                const currentPoint = event.currentTarget;
                if (currentPoint.classList.contains('selected')) {
                  return;
                }
                const allProductPoints = document.querySelectorAll('.product-point');
                allProductPoints.forEach((p) => {
                  const detailsContainer = p.querySelector('.product-preview__details-container');
                  p.classList.remove('selected');
                  detailsContainer.classList.add('hidden');
                });
                const detailsContainer = currentPoint.querySelector('.product-preview__details-container');
                currentPoint.classList.add('selected');
                detailsContainer.classList.remove('hidden');
                this.adjustPopupPosition(detailsContainer);
              });
            }
            point.addEventListener('click', (event) => {
              // event.preventDefault();
              productPoints.forEach((p) => {
                const detailsContainer = p.querySelector('.product-preview__details-container');
                if (p !== point) {
                  p.classList.remove('selected');
                  detailsContainer.classList.add('hidden');
                } else {
                  p.classList.add('selected');
                  detailsContainer.classList.remove('hidden');
                  this.adjustPopupPosition(detailsContainer);
                }
              });
            });
            const detailsContainer = point.querySelector('.product-preview__details-container');
            const addToCartButton = detailsContainer.querySelector('.product-preview__add-to-cart-btn');
            const loadingSpinner = detailsContainer.querySelector('.loading__spinner');
            if (addToCartButton) {
              addToCartButton.addEventListener('click', (e) => {
                e.stopPropagation();
                addToCartButton.classList.add('hidden');
                loadingSpinner.classList.remove('hidden');
                const productId = point.getAttribute('data-product-id');
                const formData = {
                  items: [
                    {
                      id: productId,
                      quantity: 1,
                    },
                  ],
                };
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formData),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    // Optionally, you can show a success message or update the cart icon
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'shop-the-look',
                      productVariantId: productId,
                      cartData: data
                    });
                    loadingSpinner.classList.add('hidden');
                    addToCartButton.classList.remove('hidden');
                  })
                  .catch((error) => {
                    console.error('Error adding product to cart:', error);
                    loadingSpinner.classList.add('hidden');
                    addToCartButton.classList.remove('hidden');
                  });
              });
            }
          });
          // Close details when clicking outside
          document.addEventListener('click', (event) => {
            const clickedInsideAny = Array.from(productPoints).some((p) =>
              p.contains(event.target)
            );

            if (!clickedInsideAny) {
              productPoints.forEach((p) => {
                p.classList.remove('selected');
                p.querySelector('.product-preview__details-container').classList.add('hidden');
              });
            }
          });
        });
      }

      adjustPopupPosition(popupElement) {
        popupElement.style.left = '';

        const rect = popupElement.getBoundingClientRect();
        const clippingContainer = popupElement.closest('.shop-the-look__container');
        const clippingRect = clippingContainer ? clippingContainer.getBoundingClientRect() : null;
        const padding = 16; // Add a little space from the edge
        const minLeft = clippingRect ? Math.max(padding, clippingRect.left + padding) : padding;
        const maxRight = clippingRect
          ? Math.min(window.innerWidth - padding, clippingRect.right - padding)
          : window.innerWidth - padding;
        let shiftX = 0;

        if (rect.right > maxRight) {
          shiftX = maxRight - rect.right;
        }

        if (rect.left + shiftX < minLeft) {
          shiftX += minLeft - (rect.left + shiftX);
        }

        if (shiftX !== 0) {
          const computedLeft = parseFloat(getComputedStyle(popupElement).left);
          const currentLeft = Number.isNaN(computedLeft) ? popupElement.offsetLeft : computedLeft;
          popupElement.style.left = `${currentLeft + shiftX}px`;
        }
      }
    }
  );
}
